module.exports = __webpack_public_path__ + "img/list.4fde3972.png";